import { CrewErrorBoundary } from 'components/functions/crewErrorBoundary'
import { memo } from 'react'
import { AiCreditUsageHistorySearch } from './components/aiCreditUsageHistorySearch/aiCreditUsageHistorySearch'
import { AiCreditUsageHistoryTable } from './components/aiCreditUsageHistoryTable/aiCreditUsageHistoryTable'

export const AiCreditUsageHistoryPanel = memo(() => {
  return (
    <div className="flex flex-col h-auto w-full overflow-auto gap-y-2">
      {/** AIクレジット使用履歴検索 */}
      <CrewErrorBoundary>
        <AiCreditUsageHistorySearch />
      </CrewErrorBoundary>

      {/** AIクレジット使用履歴テーブル */}
      <CrewErrorBoundary>
        <AiCreditUsageHistoryTable />
      </CrewErrorBoundary>
    </div>
  )
})
